jQuery(document).ready(function () {
      jQuery('.search-button.basel-search-full-screen .fa-search').on('click', function () {
        var topblockHeight = jQuery('.topbar-wrapp').height() || 0,
            $header = jQuery('.main-header'),
            heightHeader = $header.height();
        if ($header.hasClass('act-scroll')) topblockHeight = 0;
        jQuery('.basel-search-inner').css('maxHeight', topblockHeight + heightHeader + 3)
      });
      jQuery('.basel-search-full-screen .basel-search-wrapper').on('click', function (e) {
        var $target = e.target;

        if (!$target.closest('.basel-search-inner')) {
          jQuery('.basel-close-search').trigger('click');
        }
      });
    });